export default __webpack_public_path__ + "img/cloud-map-en.1075584.svg";